import PropTypes from 'prop-types';
import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import s from './WorkTracker.module.scss';
import { taskShape } from './propTypes';
import TaskCard from './TaskCard';
import ListHeader from './ListHeader';

export default function TaskList({
  tasks, today, openTaskId, sort, sortReverse, onSortColumn, onOpen, onStatus, onReorder, emptyText,
}) {
  if (tasks.length === 0) return <div className={s.empty}>{emptyText}</div>;
  const onDragEnd = (result) => {
    if (!result.destination || result.destination.index === result.source.index) return;
    onReorder(result.source.index, result.destination.index);
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <ListHeader sort={sort} reverse={sortReverse} onSort={onSortColumn} />
      <Droppable droppableId="work-tracker">
        {(provided) => (
          <div className={s.list} ref={provided.innerRef} {...provided.droppableProps}>
            {tasks.map((task, index) => (
              <Draggable key={task.id} draggableId={String(task.id)} index={index}>
                {(drag, snapshot) => (
                  <TaskCard
                    task={task}
                    today={today}
                    open={task.id === openTaskId}
                    dragging={snapshot.isDragging}
                    innerRef={drag.innerRef}
                    draggableProps={drag.draggableProps}
                    dragHandleProps={drag.dragHandleProps}
                    onOpen={onOpen}
                    onStatus={onStatus}
                  />
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

TaskList.propTypes = {
  tasks: PropTypes.arrayOf(taskShape).isRequired,
  today: PropTypes.instanceOf(Date).isRequired,
  openTaskId: PropTypes.number,
  sort: PropTypes.string.isRequired,
  sortReverse: PropTypes.bool,
  onSortColumn: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onStatus: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
  emptyText: PropTypes.string.isRequired,
};
TaskList.defaultProps = { openTaskId: null, sortReverse: false };
